/**
 * @fileoverview Router configuration for workflow management
 * This module defines the routes for listing, viewing, and editing workflows
 */

// Lazy load components to improve initial load time
const WorkflowList = () => import('@/views/workflows/WorkflowList.vue')
const WorkflowView = () => import('@/views/workflows/WorkflowView.vue')
const WorkflowForm = () => import('@/views/workflows/WorkflowForm.vue')

/**
 * Routes for workflow management
 *
 * Routes defined:
 * - /workflows: List all workflows
 * - /workflows/:id: View a specific workflow
 * - /workflows/:id/edit: Edit a specific workflow
 */
export const workflowRoutes = [
  {
    path: '/workflows',
    name: 'Workflows',
    component: WorkflowList,
    meta: {
      requiresAuth: true,
      title: 'Workflows'
    }
  },
  {
    path: '/workflows/new',
    name: 'NewWorkflow',
    component: WorkflowForm,
    meta: {
      requiresAuth: true,
      title: 'New Workflow'
    }
  },
  {
    path: '/workflows/:id',
    name: 'ViewWorkflow',
    component: WorkflowView,
    meta: {
      requiresAuth: true,
      title: 'View Workflow'
    }
  },
  {
    path: '/workflows/:id/edit',
    name: 'EditWorkflow',
    component: WorkflowForm,
    meta: {
      requiresAuth: true,
      title: 'Edit Workflow'
    }
  }
]
